import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// Redux
import { useSelector } from "react-redux";
// Constants - functions
import { pathHomePage, applications } from "../../config/constants";
import { renderAvatar } from "../../config/functions";
// Components
import {
  PatientDiv,
  UserDiv,
  AvatarDiv,
  AvatarImg,
  UserInfoDiv,
  UserText,
  UserInfoText,
  ShowAppsButton,
  ShowAppsImg,
  ProfileDiv,
  ProfileLink,
  ProfileImg,
  InformationDiv,
  ApplicationDiv,
  ApplicationProfileLink,
  ApplicationProfileImg,
  ApplicationLink,
  SoftwareFilterIndicator,
  ApplicationImg,
} from "./styles";
// Assets
import IcoProfile from "../../assets/ico_patient_profile.svg";
import IcoArrowUp from "../../assets/ico_arrow_up.svg";
import IcoArrowDown from "../../assets/ico_arrow_down.svg";
import RGSClinicActive from "../../assets/ico_clinic.svg";
import RGSHomeActive from "../../assets/ico_home.svg";
import RGSClinicDisabled from "../../assets/ico_clinic_disabled.svg";
import RGSHomeDisabled from "../../assets/ico_home_disabled.svg";

const PatientData = ({
  patientIndex,
  patientId,
  isThereSomePrescription,
  isTherePrescriptionsAfter7Days,
  adherence,
  user,
  gender,
  age,
  software,
  hospitalSoftwares,
  currentSoftwareFilterId,
}) => {
  const [showApps, setShowApps] = useState(false);
  const [t] = useTranslation("global");
  const clinicianToken = useSelector(({ clinician }) => clinician.data.token);
  const formattedGender = gender === "MALE" ? t("patientGender.male") : t("patientGender.female");

  const renderUserInfo = () => `${formattedGender} ${age}`;

  const renderSoftwares = () => {
    return hospitalSoftwares.map((eachSoftware) => {
      let softwareImg;
      let disabledLink = true;
      let path = "";
      const handleSetImage = (softwareId, activeImg, disabledImg, prescriptionsPath) => {
        if (software.includes(softwareId)) {
          softwareImg = activeImg;
          disabledLink = false;
          path = prescriptionsPath;
        } else {
          softwareImg = disabledImg;
        }
      };
      switch (eachSoftware.SOFTWARE_ID) {
        case applications.clinicId:
          handleSetImage(
            applications.clinicId,
            RGSClinicActive,
            RGSClinicDisabled,
            `${pathHomePage}/prescriptions/clinic/${clinicianToken}/${patientId}`
          );
          break;
        case applications.homeId:
          handleSetImage(
            applications.homeId,
            RGSHomeActive,
            RGSHomeDisabled,
            `${pathHomePage}/prescriptions/home/${clinicianToken}/${patientId}`
          );
          break;
        default:
          break;
      }
      let display = "none";
      if (eachSoftware.SOFTWARE_ID === currentSoftwareFilterId) {
        display = "flex";
      }
      return (
        <ApplicationLink key={eachSoftware.SOFTWARE_ID} to={path} disabled={disabledLink} display={display}>
          {patientIndex === 0 && <SoftwareFilterIndicator display={display} />}
          <ApplicationImg src={softwareImg} alt="software-icon" />
        </ApplicationLink>
      );
    });
  };

  const handleShowApps = (e) => {
    e.preventDefault();
    setShowApps(!showApps);
  };

  return (
    <PatientDiv>
      <UserDiv>
        <AvatarDiv>
          <AvatarImg src={renderAvatar(isThereSomePrescription, isTherePrescriptionsAfter7Days, adherence)} alt="avatar" />
        </AvatarDiv>
        <UserInfoDiv>
          <UserText>{user}</UserText>
          {/* Responsive view */}
          <UserInfoText>{renderUserInfo()}</UserInfoText>
        </UserInfoDiv>
        <ShowAppsButton onClick={handleShowApps}>
          <ShowAppsImg src={showApps ? IcoArrowUp : IcoArrowDown} alt="ico-arrow" />
        </ShowAppsButton>
      </UserDiv>
      <ProfileDiv>
        <ProfileLink to={`${pathHomePage}/edit-patient/${clinicianToken}/${patientId}`}>
          <ProfileImg src={IcoProfile} alt="profile" />
        </ProfileLink>
      </ProfileDiv>
      {/* Desktop view */}
      <InformationDiv>
        <p>{renderUserInfo()}</p>
      </InformationDiv>
      <ApplicationDiv show={showApps}>
        <ApplicationProfileLink to={`${pathHomePage}/edit-patient/${clinicianToken}/${patientId}`}>
          <ApplicationProfileImg src={IcoProfile} alt="profile" />
        </ApplicationProfileLink>
        {renderSoftwares()}
      </ApplicationDiv>
    </PatientDiv>
  );
};

export default PatientData;
